import { render } from "./Address.vue?vue&type=template&id=5ee36830"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"

import "./Address.vue?vue&type=style&index=0&id=5ee36830&lang=less"

import exportComponent from "E:\\vue-prj\\newbee-mall-vue3-app-main\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__